module.exports = __webpack_public_path__ + "img/35-Damaged.9d951819.png";